module.exports = __webpack_public_path__ + "img/logo_bottom.1531bc31.svg";